module.exports = __webpack_public_path__ + "static/media/3.70cd5e88.jpg";